let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bSCNR")).then(() => parcelRequire('eC9dN'));